import React from 'react';

const AboutTabs = ({ inPageTabs, activeTab, onTabChange }) => {
    return (
        <div className="inPageTabs">
            {inPageTabs.map((tab) => (
                <div
                    key={tab.name}
                    className={`tab ${activeTab === tab.name ? 'active' : ''}`}
                    onClick={() => onTabChange(tab.name)}
                >
                    {tab.label}
                </div>
            ))}
        </div>
    );
};

export default AboutTabs;
